import Loader from 'react-loader-spinner';
import makeStyles from './style';

const Loading = ({ visible }) => {
  const classes = makeStyles();

  return (
    <div className={`${visible ? classes.loaderContainer : ''}`}>
      <Loader
        visible={visible}
        type="ThreeDots"
        color="#4CAF50"
        height={80}
        width={80}
      />
    </div>
  );
};

export default Loading;
